import type React from "react";
import AppHeader from "@/components/common/AppHeader";
import type { UploadHeaderProps } from "@/types";

const UploadHeader: React.FC<UploadHeaderProps> = ({ onBack }) => {
	const centerContent = (
		<div className="upload-header-content">
			<h1>Document Upload</h1>
			<p>Upload a document to automatically extract entities and relationships</p>
		</div>
	);

	return <AppHeader centerContent={centerContent} onBack={onBack} showBackButton={true} variant="upload" />;
};

export default UploadHeader;
